import { SaveButton } from '@lib/core/src';
import palette from '@lib/core/src/theme/palette';
import SearchIcon from '@mui/icons-material/Search';
import { Stack, Typography } from '@mui/material';

export const MeetingHubEmptyState = ({ initFilters }: { initFilters: () => void }) => (
  <Stack
    sx={{
      background: palette.grey[800],
      flex: 1,
      gap: '8px',
      textAlign: 'center',
      minHeight: '350px',
      borderRadius: '16px',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <SearchIcon sx={{ color: palette.grey[400], marginBottom: '12px', fontSize: '70px' }} />
    <Typography sx={{ fontWeight: 600, fontSize: '16px', color: palette.black }}>
      No Results Found
    </Typography>
    <Typography sx={{ fontWeight: 600, fontSize: '13px', color: palette.grey[400] }}>
      Try adjusting your filters to find what you are looking for.
    </Typography>
    <SaveButton sx={{ height: '32px' }} onClick={initFilters}>
      View all meetings
    </SaveButton>
  </Stack>
);
